import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IonNav, IonSearchbar } from '@ionic/angular';
import { ProvinceModel } from 'src/app/shared-lib/global/models';

const removeDiacritics = (value: string): string =>
  value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');



@Component({
  selector: 'app-province',
  templateUrl: './province.component.html',
  standalone: false
})
export class ProvinceComponent implements OnInit, AfterViewInit {

  @ViewChild('searchbar') searchBar: IonSearchbar;

  //____________

  provinceControl: UntypedFormControl = null; //----> usado para controlar la provincia entrante
  provinceIdControl: UntypedFormControl = null; //----> usado para controlar la provincia entrante

  //____________

  searchControl = new UntypedFormControl(''); //--> con el que buscaremos



  allProvinces: Array<ProvinceModel> = [];
  provinceList: Array<ProvinceModel> = [];


  constructor(
    private http: HttpClient,
    private nav: IonNav,

  ) {

  }

  ngOnInit() {
    this.getProvinces();

    if (!!this.provinceControl.value) {
    } else {
      this.provinceControl.setValue('');
    }

    this.searchControl.setValue(this.provinceControl.value);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.searchBar.setFocus();
    }, 150);
  }

  async getProvinces() {

    await this.http
      .get<any>('./assets/data/provincias.json')
      .toPromise()
      .then((data: ProvinceModel[]) => {
        this.allProvinces = data;
        this.search_item();
      });
  }


  search() {
    //te permita coger el primero del array en caso de haber
    if (this.provinceList.length > 0) {
      this.choose(this.provinceList[0]);
    }
    //ver como añadir
    // Keyboard.hide();
  }

  //Este va buscando a medida que tecleas
  search_item() {

    const qry = removeDiacritics(this.searchControl.value.toLowerCase());
    this.provinceList = []; //vacio la lista


    this.provinceList = this.allProvinces
      .filter(prov => {
        let newProv: string = prov.nombre.toLowerCase();
        newProv = removeDiacritics(newProv);
        return newProv.includes(qry);
      });
  }




  //Se escoge la provincia y se envía a el root
  choose(province: ProvinceModel) {
    this.provinceControl.setValue(province.nombre);
    this.provinceIdControl.setValue(province.provincia_id);// debería traer un number
    this.provinceControl.markAsDirty();
    this.provinceIdControl.markAsDirty();
    this.goBack();
  }
  // Te lleva a atrás
  goBack() {
    this.nav.popToRoot();
  }


}
